import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    .vcv-timeline {
      position: relative;
      display: flex;
      align-items: center;
      max-width: 1000px;
      margin: 0 auto;
      padding: 0;
      list-style-type: none;
      color: ${theme.colors.containerGray};
    }

    .vcv-timeline-item {
      min-width: 200px;
      display: flex;
      align-items: center;

      padding: 0;
      position: relative;
      &::before,
      &::after {
        content: '';
      }

      &::after {
        content: '';
        position: absolute;
        height: 2px;
        background: ${theme.colors.containerGray};
        width: 100%;
        margin: 0 10px;
      }

      &:last-of-type {
        flex: 0 0 120px;
        &::after {
          display: none;
        }
      }

      &.vcv-step-done {
        &::before {
          content: '';
          border-color: ${theme.colors.primary};
          background: ${theme.colors.white} no-repeat center;
          background-size: 40%;
        }

        &::after {
          background: ${theme.colors.primary};
        }
      }
      span {
        display: flex;
        justify-content: center;
        align-items: center;
        background: ${theme.colors.white};

        height: 45px;
        width: 45px;
        margin: 0 10px 0 0;
        border-radius: 50%;
        border: 2px solid ${theme.colors.containerGray};
        color: ${theme.colors.containerGray};
        z-index: 2;
        font-size: ${theme.font.sizes.medium};

        &.ativo {
          border: 2px solid ${theme.colors.primary};
          color: ${theme.colors.primary};
        }
      }
      p {
        font-size: 10px;
        color: ${theme.colors.containerGray};
        margin-bottom: 3rem;
        &.ativo {
          color: ${theme.colors.primary};
        }
      }
    }
  `}
`
